(function () {
  'use strict';
  var heading = document.getElementById('cc-product-reviews');
  if (!heading) return;
  var expanded = false, widget = null, observer = null, queued = false;
  function reviewRoot() {
    return document.querySelector('#judgeme_product_reviews .jdgm-rev-widg, #judgeme_product_reviews .jdgm-review-widget, #judgeme_product_reviews, .jdgm-review-widget');
  }
  function hydrate() {
    queued = false;
    var root = reviewRoot();
    if (!root) return;
    var reviews = Array.prototype.slice.call(root.querySelectorAll('.jdgm-rev-widg__reviews > .jdgm-rev'));
    if (!reviews.length) reviews = Array.prototype.slice.call(root.querySelectorAll('.jdgm-review-card'));
    var btn = document.getElementById('cc-show-more-product-reviews');
    if (reviews.length <= 3) {
      reviews.forEach(function(r){r.hidden=false;r.classList.remove('cc-hidden-review');});
      if (btn) btn.remove();
      return;
    }
    reviews.forEach(function(r,i) {
      var hidden = !expanded && i >= 3;
      r.hidden = hidden;
      r.classList.toggle('cc-hidden-review', hidden);
    });
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';btn.id = 'cc-show-more-product-reviews';
      btn.className = 'btn cc-show-more-product-reviews';
      btn.setAttribute('aria-controls',root.id || 'cc-product-reviews');
      btn.addEventListener('click',function(){expanded=!expanded;hydrate();});
      // Keep Judge.me pagination in place: this button toggles only loaded review cards.
      var pagination = root.querySelector('.jdgm-paginate');
      if (pagination) pagination.parentNode.insertBefore(btn,pagination);
      else root.appendChild(btn);
    }
    btn.textContent = expanded ? 'Show fewer reviews' : 'View more reviews';
    btn.setAttribute('aria-expanded',String(expanded));
  }
  function schedule(){if(queued)return;queued=true;window.requestAnimationFrame(hydrate);}
  function mount(){
    var root=reviewRoot();if(!root)return false;
    if(widget===root)return true;
    if(observer)observer.disconnect();widget=root;
    observer=new MutationObserver(function(m){
      if(m.some(function(x){return x.type==='childList' && !Array.prototype.some.call(x.addedNodes,function(n){return n.id==='cc-show-more-product-reviews';});}))schedule();
    });
    observer.observe(root,{subtree:true,childList:true});schedule();return true;
  }
  function activate(){
    if(mount())return;
    var tries=0;
    var poll=window.setInterval(function(){if(mount()||++tries>=12)window.clearInterval(poll);},500);
    window.addEventListener('pagehide',function(){window.clearInterval(poll);if(observer)observer.disconnect();},{once:true});
  }
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(e){if(e.some(function(x){return x.isIntersecting})){io.disconnect();activate();}},{rootMargin:'700px'});
    io.observe(heading);
  }else if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',activate,{once:true});
  else activate();
})();
